import Repository from "@/repositories/api.js"
const resource = "/support_organizations/pretix"

export default {
  async connect() {
    let response = await Repository.get(`${resource}/connect`)
    return response.data.authorization_url
  },
  async callback(code, state) {
    let response = await Repository.get(`${resource}/callback`, {
      params: { code, state }
    })
    return response.data
  },
  async disconnect() {
    let response = await Repository.delete(`${resource}/disconnect`)
    return response.data
  },
  async status() {
    let response = await Repository.get(`${resource}/status`)
    return response.data
  },
  async update(organizerSlug) {
    let response = await Repository.patch(`${resource}/update`, {
      pretix_connection: { organizer_slug: organizerSlug }
    })
    return response.data
  },
  async events() {
    let response = await Repository.get(`${resource}/events`)
    return response.data.events
  }
}
